import { useState, useRef } from 'react'
import { apiJson, resolveImageUrl } from '../../lib/api'
import { ui } from './shared'

interface UploadResult { ok: true; key: string; url: string }

export function MediaPicker({
  value, onChange,
}: { value: string; onChange: (url: string) => void }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const ref = useRef<HTMLInputElement>(null)

  async function upload(file: File) {
    setBusy(true)
    setError(null)
    try {
      const form = new FormData()
      form.append('file', file)
      const r = await fetch('/api/admin/media', {
        method: 'POST',
        credentials: 'same-origin',
        body: form,
      })
      if (!r.ok) throw new Error(`upload ${r.status}`)
      const res = (await r.json()) as UploadResult
      onChange(res.url)
    } catch (err) {
      setError(String(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        {value ? (
          <img src={resolveImageUrl(value)} alt=""
               style={{ width: 96, height: 96, objectFit: 'cover', border: '1px solid var(--line)' }} />
        ) : (
          <div style={{ width: 96, height: 96, background: 'var(--paper)', border: '1px dashed var(--line)' }} />
        )}
        <div style={{ flex: 1 }}>
          <input style={{ ...ui.input, marginBottom: 8 }} value={value}
                 placeholder="/assets/foo.jpg oppure /api/media/uploads/…"
                 onChange={(e) => onChange(e.target.value)} />
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" style={ui.btnGhost} onClick={() => ref.current?.click()} disabled={busy}>
              {busy ? 'Carico…' : 'Carica file'}
            </button>
            {value && (
              <button type="button" style={ui.btnDanger} onClick={() => onChange('')}>
                Rimuovi
              </button>
            )}
          </div>
          <input ref={ref} type="file" accept="image/*" style={{ display: 'none' }}
                 onChange={(e) => {
                   const f = e.target.files?.[0]
                   if (f) { upload(f); e.target.value = '' }
                 }} />
          {error && <div style={{ color: '#a33', fontSize: 12, marginTop: 6 }}>{error}</div>}
        </div>
      </div>
    </div>
  )
}

export async function listMedia() {
  return apiJson<{ rows: { r2_key: string; mime: string; size_bytes: number; uploaded_at: number }[] }>('/api/admin/media')
}

export async function deleteMedia(key: string) {
  await apiJson(`/api/admin/media/${encodeURI(key)}`, { method: 'DELETE' })
}
